import * as types from '../actions/action-types';
import _ from 'lodash';
var socket = io.connect("https://www.versity.co/");
//var socket = io.connect("http://dev.versity.co:8000");
//var socket = io.connect("https://cdnjs.cloudflare.com/ajax/libs/socket.io/1.2.0/socket.io.min.js");
const initialState = {
  msg: {},
	group:{},
	socket:socket,cvst:0,refreshMsg:false,refreshNoti:false,refreshSideBar:false
};

const msgReducer = function(state = initialState, action) {

  switch(action.type) {

    case types.MSG_CHANGED:
      return Object.assign({},state, {msg:action.data});
      case types.OPEN_CHATGROUP:
      return Object.assign({},state, {group:action.group});
      case types.MESSAGE_RECEIVE:
      return Object.assign({},state, {msg:action.data});
      case types.CVST_CHANGED:
      return Object.assign({},state, {cvst:action.data.value});
      case types.REFRESH_MSG:
      return Object.assign({},state, {refreshMsg:action.data.value});
      case types.REFRESH_NOTI:
      return Object.assign({},state, {refreshNoti:action.data.value});
      case types.REFRESH_SIDEBAR:
      return Object.assign({},state, {refreshSideBar:action.data.value});
  }

  return state;

}

export default msgReducer;



/** WEBPACK FOOTER **
 ** ./src/client/app/reducers/msg-reducer.js
 **/